import React from "react";
import PartBar from "../../components/bars/PartBar";
import { PagePagination } from "../assessment/PagePagination";
import { size } from "lodash";

export const B2CPagination = ({
  currentSectionPage,
  setCurrentSectionPage,
  data,
  currentPage,
  setCurrentPage,
  visited_pages,
  answers,
  pagination_color_decision,
  isAiGradingexercise,
  AisubmissionCounter,
  setAisubmissionCounter
}) => {
  const ClickOnPart = (props) => {
    setCurrentPage(props);
    setCurrentSectionPage(parseInt(`${props}${1}`));
    if(props > currentPage)
    {
      if(isAiGradingexercise && data?.is_premium && AisubmissionCounter > 0)
      {
        setAisubmissionCounter(parseInt(
          `${AisubmissionCounter - 1}`
        ))
      }
    }
    else if (props < currentPage){
      if(AisubmissionCounter < data?.remaining_credits)
      {
        setAisubmissionCounter(parseInt(
          `${AisubmissionCounter + 1}`
        ))
      }
    }
  };
  const ClickOnPage = (section_number, page_number) => {
    setCurrentPage(section_number);
    setCurrentSectionPage(page_number);
  };

  return (
    <>
      <div className="d-flex col-12 justify-content-start pt-2">
        {data &&
          data.sections &&
          size(data.sections) > 1 &&
          data.sections.map((section, section_id) => {
            return (
              <div className="inline-grid pe-2 col-lg-2 col-sm-3 col-4 bg-white">
                <div onClick={() => ClickOnPart(section.section_number)} className="inline-grid" style={{cursor: "pointer"}}>
                <PartBar
                  currentPage={section.section_number}
                  pagination_color_decision={pagination_color_decision}
                  section_number={section.section_number}
                  standing_page={currentPage}
                  data={data}
                  answers={answers}
                  // onClick={(props) => ClickOnPart(props)}
                />
                {size(data.sections) > 1 ? (
                  <b className="text-center w-100 pt-1">
                    {section.section_name}
                  </b>
                ) : null}
                </div>
                <div>
                  {section &&
                    section.pages.map((page, page_id) => {
                      return (
                        <PagePagination
                          data={data}
                          pagination_color_decision={pagination_color_decision}
                          visited_pages={visited_pages}
                          answers={answers}
                          page_number={page.page_number}
                          section_number={section.section_number}
                          page_id={page_id + 1}
                          currentSectionPage={parseInt(
                            `${section.section_number}${page.page_number}`
                          )}
                          currentStandingPage={currentSectionPage}
                          section={section.section_number}
                          onClick={(section_number, page_number) =>
                            ClickOnPage(section_number, page_number)
                          }
                        />
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};
